import React, { useState, useEffect } from "react";
import useDataSourceManager from "hooks/useDataSourceManager";
import { v4 as uuidv4 } from "uuid";

import { Box, Typography, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const News = ({ selected }) => {
  const theme = useTheme();
  return (
    <Box sx={{ padding: "20px 30px" }}>
      <Typography
        sx={{
          color: theme.palette.primary.main,
          fontSize: theme.typography.customFontSize[5],
          fontWeight: theme.typography.customFontWeight[1],
        }}
      >
        {selected?.title}
      </Typography>
      <Divider sx={{ margin: "20px 0" }} />
      <Box sx={{ padding: "10px 0 60px 0" }}>
        <Box
          sx={{
            color: theme.palette.primary.greyPrimary,
            fontSize: theme.typography.customFontSize[2],
          }}
          dangerouslySetInnerHTML={{ __html: selected?.content }}
        />
      </Box>
    </Box>
  );
};

export default News;
